import React, { useState, useEffect } from 'react';
import Pagination from 'react-js-pagination';
import { useSelector } from 'react-redux';
import { NavLink, useHistory, useLocation } from 'react-router-dom';
import Table from 'react-bootstrap/Table';
import { toast } from 'react-toastify';
import { useMutation, useQuery } from 'react-query';
import { TINH_API, XA_API } from '@app/utils/apiUrl.js';
import { DeleteSingle, Get } from '@app/utils/httpProvider';
import { ConfirmModal } from '@app/modules/modal/ConfirmModal';
import { messageToast, objectShowNumber } from '@app/utils/define';
import { createUrlWithParam } from '@app/utils/helper';
import { URI_INTERNAL } from '@app/utils/pathLocations';

const Xa = () => {
    const history = useHistory();
    const location = useLocation();
    const valueSearch = useSelector((state) => state.search.valueSearch);

    const [page, setPage] = useState(1);
    const [pageSize, setPageSize] = useState(20);
    const [search, setSearch] = useState('');
    const [selectedTinhId, setSelectedTinhId] = useState('');

    const [openConfirmDeleteModal, setOpenConfirmDeleteModal] = useState(false);
    const [idWantDelete, setIdWantDelete] = useState('');
    const [confirmDelMessage, setConfirmDelMessage] = useState('');

    const tinhList = useQuery(['tinhFilterOptions'], () => Get(TINH_API.GET_ALL));

    const deleteFunc = useMutation((value) =>
        DeleteSingle(XA_API.DELETE_ITEM, value, null)
    );

    const paramUrl = new URLSearchParams(location.search.substring(1));
    if (
        paramUrl.get('page') != null &&
        parseInt(paramUrl.get('page'), 10) !== page
    ) {
        setPage(parseInt(paramUrl.get('page'), 10));
    }
    if (
        paramUrl.get('size') != null &&
        parseInt(paramUrl.get('size'), 10) !== pageSize
    ) {
        setPageSize(parseInt(paramUrl.get('size'), 10));
    }
    if (paramUrl.get('search') != null && paramUrl.get('search') !== search) {
        setSearch(paramUrl.get('search'));
    }
    if (paramUrl.get('tinhId') != null && paramUrl.get('tinhId') !== selectedTinhId) {
        setSelectedTinhId(paramUrl.get('tinhId'));
    }

    const { isLoading, isError, error, data, refetch } = useQuery(
        ['xaData', valueSearch, page, pageSize, selectedTinhId],
        () => {
            const model = {
                Keyword: valueSearch ? valueSearch : '',
                PageIndex: page,
                PageSize: pageSize
            };

            if (selectedTinhId && selectedTinhId !== '') {
                model.TinhId = selectedTinhId;
            }

            replaceHistory(page, pageSize, valueSearch ? valueSearch : '', selectedTinhId);
            return Get(XA_API.GET_PAGING, null, model);
        }
    );

    useEffect(() => {
        refetch();
    }, [pageSize, page, selectedTinhId]);

    useEffect(() => {
        if (valueSearch != null && valueSearch !== search) {
            replaceHistory(1, pageSize, valueSearch, selectedTinhId);
        }
    }, [valueSearch]);

    const replaceHistory = async (Page, Size, Search, TinhId) => {
        const queryParams = {
            page: Page,
            size: Size,
            search: Search
        };
        if (TinhId && TinhId !== '') {
            queryParams.tinhId = TinhId;
        }

        history.replace(
            createUrlWithParam(URI_INTERNAL.XA_PATH, queryParams)
        );
    };

    const changePage = (number) => {
        setPage(number);
        replaceHistory(number, pageSize, search, selectedTinhId);
    };

    const onChangeShowNumber = (e) => {
        const newSize = Number(e.target.value);
        setPageSize(newSize);
        replaceHistory(page, newSize, search, selectedTinhId);
    };

    const onChangeTinhFilter = (e) => {
        const newTinhId = e.target.value;
        setSelectedTinhId(newTinhId);
        setPage(1);
        replaceHistory(1, pageSize, search, newTinhId);
    };

    const deleteAction = (id, name) => {
        setIdWantDelete(id);
        setConfirmDelMessage(name);
        setOpenConfirmDeleteModal(true);
    };

    const acceptDelete = async () => {
        if (idWantDelete !== '') {
            deleteFunc.mutate(idWantDelete, {
                onSuccess: (res) => {
                    if (res && (res.status === 200 || res.status === 201)) {
                        refetch();
                        toast.success(messageToast.messageToastDeleteSuccess);
                        if (
                            data != null &&
                            data.data &&
                            data.data.length === 1 &&
                            page !== 1
                        ) {
                            const queryParams = {
                                page: page - 1,
                                size: pageSize,
                                search: search
                            };
                            if (selectedTinhId) queryParams.tinhId = selectedTinhId;

                            history.push(
                                createUrlWithParam(URI_INTERNAL.XA_PATH, queryParams)
                            );
                        }
                    } else {
                        toast.error(messageToast.messageToastDeleteError);
                    }
                },
                onError: () => {
                    toast.error(messageToast.messageToastTryCatch);
                }
            });

            replaceHistory(page, pageSize, search, selectedTinhId);
            setOpenConfirmDeleteModal(false);
        }
    };

    const cancelDelete = () => {
        setIdWantDelete('');
        setOpenConfirmDeleteModal(false);
    };

    return (
        <div className="container-fluid">
            <div className="row">
                <div className="col-lg-12">
                    <div className="card">
                        <div className="card-header d-flex justify-content-between align-items-center">
                            <h3 className="card-title">Danh sách xã / phường</h3>
                        </div>
                        <div className="card-body">
                            <div className="d-flex justify-content-between align-items-center flex-wrap mb-3">
                                <div className="d-flex align-items-center flex-wrap">
                                    <form className="form-inline mr-3 mb-2">
                                        <label htmlFor="showNumber" className="mr-2">
                                            Hiển thị :
                                        </label>
                                        <select
                                            id="showNumber"
                                            className="form-control"
                                            value={pageSize}
                                            onChange={(e) => onChangeShowNumber(e)}
                                        >
                                            {objectShowNumber.map((item, key) => (
                                                <option key={Number(key)} value={item.value}>
                                                    {item.text}
                                                </option>
                                            ))}
                                        </select>
                                    </form>

                                    <form className="form-inline mb-2">
                                        <label htmlFor="filterTinh" className="mr-2">
                                            Lọc theo Tỉnh/TP :
                                        </label>
                                        <select
                                            id="filterTinh"
                                            className="form-control"
                                            value={selectedTinhId}
                                            onChange={(e) => onChangeTinhFilter(e)}
                                            style={{ minWidth: '220px' }}
                                        >
                                            <option value="">-- Tất cả tỉnh / thành phố --</option>
                                            {tinhList.data &&
                                                Array.isArray(tinhList.data) &&
                                                tinhList.data.map((t) => (
                                                    <option key={t.id || t.Id} value={t.id || t.Id}>
                                                        {t.tenTinh || t.TenTinh}
                                                    </option>
                                                ))}
                                        </select>
                                    </form>
                                </div>

                                <div className="mb-2">
                                    <NavLink
                                        className="nav-link-reject nav-link p-0"
                                        to={URI_INTERNAL.XA_CREATE_PATH}
                                    >
                                        <button type="button" className="btn btn-info">
                                            Thêm mới
                                        </button>
                                    </NavLink>
                                </div>
                            </div>

                            {isLoading ? (
                                <div>Đang tải...</div>
                            ) : isError ? (
                                <div>Có lỗi xảy ra: {error?.message}</div>
                            ) : (
                                <div className="table-responsive">
                                    <Table striped bordered hover>
                                        <thead>
                                            <tr>
                                                <th style={{ width: '80px', textAlign: 'center' }}>STT</th>
                                                <th>Tên xã / phường</th>
                                                <th>Thuộc tỉnh / thành phố</th>
                                                <th style={{ width: '160px', textAlign: 'center' }}>Hành động</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {data && data.data && data.data.length > 0 ? (
                                                data.data.map((item, index) => (
                                                    <tr key={item.id || item.Id || index}>
                                                        <td style={{ textAlign: 'center' }}>
                                                            {(page - 1) * pageSize + index + 1}
                                                        </td>
                                                        <td>{item.tenXa || item.TenXa}</td>
                                                        <td>{item.tenTinh || item.TenTinh || 'Chưa xác định'}</td>
                                                        <td style={{ textAlign: 'center' }}>
                                                            <NavLink
                                                                className="btn btn-sm btn-primary mr-2"
                                                                to={`${URI_INTERNAL.XA_EDIT_PATH}?id=${item.id || item.Id}`}
                                                            >
                                                                Sửa
                                                            </NavLink>
                                                            <button
                                                                type="button"
                                                                className="btn btn-sm btn-danger"
                                                                onClick={() =>
                                                                    deleteAction(
                                                                        item.id || item.Id,
                                                                        item.tenXa || item.TenXa || ''
                                                                    )
                                                                }
                                                            >
                                                                Xóa
                                                            </button>
                                                        </td>
                                                    </tr>
                                                ))
                                            ) : (
                                                <tr>
                                                    <td colSpan="4" className="text-center">
                                                        Không có dữ liệu.
                                                    </td>
                                                </tr>
                                            )}
                                        </tbody>
                                    </Table>
                                </div>
                            )}

                            {data && data.totalRecords > pageSize && (
                                <div className="d-flex justify-content-end mt-3">
                                    <Pagination
                                        activePage={page}
                                        itemsCountPerPage={pageSize}
                                        totalItemsCount={data.totalRecords}
                                        pageRangeDisplayed={5}
                                        onChange={changePage}
                                        itemClass="page-item"
                                        linkClass="page-link"
                                    />
                                </div>
                            )}
                        </div>
                    </div>
                </div>
            </div>
            <ConfirmModal
                isOpen={openConfirmDeleteModal}
                confirmType="delete"
                handleAccept={() => acceptDelete()}
                handleCancel={() => cancelDelete()}
                content={confirmDelMessage}
            />
        </div>
    );
};

export default Xa;
